import script from "./RoleRequiredCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleRequiredCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./RoleRequiredCalendar.vue?vue&type=style&index=0&id=aec13b8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aec13b8c"]])

export default __exports__